import React, { useEffect } from "react";
import "./KaramalePolicy.css"; // Optional: add your styles here
import Header3 from "./components/Header3";
import Header from "./components/Header";
import Header2 from "./components/Header2";
import Header5 from "./components/Header5";

function KaramalePolicy() {
  useEffect(() => {
    document.title = "Karamale Ticketing Policy";
  }, []);
  return (
    <>
      {localStorage.getItem("customername") !== null ? (
        <Header2 />
      ) : localStorage.getItem("businessname") !== null ? (
        <Header3 />
      ) : localStorage.getItem("partner") !== null ? (
        <Header5 />
      ) : (
        <Header />
      )}
      <div className="container">
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-8 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search">
              <h3>Karamale Ticketing Policy</h3>

              <section className="fade-in">
                <h4>1. Ticket Validity & Entry</h4>
                <ul>
                  <li>
                    Each ticket grants a <strong>revocable license</strong> for
                    entry to the specified event.
                  </li>
                  <li>
                    Tickets are valid for <strong>one-time use only</strong> and
                    are linked to a unique QR code and ticket number.
                  </li>
                  <li>
                    Entry requires a valid, scannable ticket; failure to present
                    one may result in denied access.
                  </li>
                  <li>
                    <strong>Scanned tickets</strong> are considered used and
                    cannot be reused or transferred.
                  </li>
                </ul>
              </section>

              <section className="fade-in">
                <h4>2. Digital Tickets vs. Actual Tickets</h4>
                <ul>
                  <li>
                    All <strong>digital tickets</strong> are delivered directly
                    to the buyer's <strong>Karamale account</strong>.
                  </li>
                  <li>
                    Each digital ticket appears as a <strong>QR code</strong>{" "}
                    showing key details like ticket type and number.
                  </li>
                  <li>
                    Buyers <strong>tap to zoom</strong> the QR code for venue
                    scanning — no extra actions, printing, or downloads
                    required.
                  </li>
                  <li>
                    There are <strong>no “actual tickets”</strong> issued for
                    digital purchases; the QR code <em>is</em> the ticket.
                  </li>
                  <li>
                    <strong>Actual tickets</strong> refer to physical print-outs
                    and are only used for offline or manually distributed
                    events.
                  </li>
                </ul>
              </section>

              <section className="fade-in">
                <h4>3. Ticket Ownership & Transfer</h4>
                <ul>
                  <li>
                    Tickets are <strong>non-transferable</strong> unless
                    explicitly permitted by the event organiser.
                  </li>
                  <li>
                    Resale or promotional use requires written consent from
                    Karamale.
                  </li>
                  <li>
                    Tickets bought via unauthorised platforms may be invalid and
                    denied at entry.
                  </li>
                </ul>
              </section>

              <section className="fade-in">
                <h4>4. Security & Verification</h4>
                <ul>
                  <li>
                    Secure QR validation prevents counterfeit tickets and fraud.
                  </li>
                  <li>
                    All entry attempts and organiser overrides are logged for
                    transparency and auditing.
                  </li>
                  <li>
                    Tampering or repeated abuse may result in blacklisting or
                    legal action.
                  </li>
                </ul>
              </section>

              <section className="fade-in">
                <h4>5. Event Changes & Notifications</h4>
                <ul>
                  <li>
                    Event details are subject to change; Karamale will notify
                    buyers via email, SMS, or dashboard alerts.
                  </li>
                  <li>
                    Buyers must keep their contact info up to date to ensure
                    smooth communication.
                  </li>
                </ul>
              </section>

              <section className="fade-in">
                <h4>6. Organiser Rights</h4>
                <ul>
                  <li>
                    Organisers may deny entry for safety, compliance, or
                    capacity reasons.
                  </li>
                  <li>
                    They reserve the right to adjust venue layout or enforce
                    restrictions (age, dress code, etc.).
                  </li>
                  <li>
                    Overrides to ticketing rules are permitted under special
                    circumstances and are logged securely.
                  </li>
                </ul>
              </section>

              <section className="fade-in">
                <h4>7. Refunds</h4>
                <p>
                  For refund eligibility, fees, and timing, please see our{" "}
                  <a href="/refund-policy">Refund Policy</a>.
                </p>
              </section>

              <section className="fade-in">
                <h4>8. Support</h4>
                <p>
                  If you have trouble accessing your ticket, entering the event,
                  or managing your account:
                </p>
                <ul>
                  <li>
                    Reach out via your dashboard or email us at{" "}
                    <a href="mailto:support@karamale.com">
                      support@karamale.com
                    </a>
                  </li>
                  <li>
                    Include your ticket number and event name for faster help.
                  </li>
                  <li>
                    We respond within <strong>48 hours</strong>.
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default KaramalePolicy;
